<template>
  <div class="py-5 px-4">
    <b-row>
      <b-col cols="4">
        <b-row>
          <b-col cols="3">
            <b>Name</b>
          </b-col>
          <b-col cols="10">
            {{ user.first_name }} {{ user.last_name }}
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col cols="3">
            <b>Email</b>
          </b-col>
          <b-col cols="10">
            {{ user.email }}
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col cols="3">
            <b>Gender</b>
          </b-col>
          <b-col cols="10">
            {{ user.gender }}
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col cols="3">
            <b>Phone</b>
          </b-col>
          <b-col cols="10">
            {{ user.phone }}
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col cols="3">
            <b>About me</b>
          </b-col>
          <b-col cols="10">
            {{ user.description }}
          </b-col>
        </b-row>
      </b-col>

      <!-- <b-col cols="8">
        <b-row class="">
          <b-col class="p-1">
            <div class="sg-badge off center-base all">
              <div>
                <font-awesome-icon icon="star" /> Rating
              </div>
            </div>
          </b-col>
          <b-col class="p-1">
            <div class="sg-badge off center-base all">
              <div>
                <font-awesome-icon icon="paw" /> Order
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row class="">
          <b-col cols="3" class="p-1">
            <div class="sg-badge off center-base all">
              <div>
                <font-awesome-icon icon="snowboarding" /> Achievement 1
              </div>
            </div>
          </b-col>
          <b-col cols="3" class="p-1">
            <div class="sg-badge off center-base all">
              <div>
                <font-awesome-icon icon="skiing-nordic" /> Achievement 2
              </div>
            </div>
          </b-col>
          <b-col cols="3" class="p-1">
            <div class="sg-badge off center-base all">
              <div>
                <font-awesome-icon icon="skiing" /> Achievement 3
              </div>
            </div>
          </b-col>
          <b-col cols="3" class="p-1">
            <div class="sg-badge off center-base all">
              <div>
                <font-awesome-icon icon="hiking" /> Achievement 4
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col> -->
    </b-row>
  </div>
</template>

<script>
// external dependencies

// custom component

// api call

export default {
  name: 'MyAccount_BasicInfo',
  props: ['user'],
  data () {
    return {
    }
  },
  methods: {
    // PREREQUISITES
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
.sg-badge {
  min-height: 5em;
  color: #233c7c;
}
</style>



// WEBPACK FOOTER //
// src/components/MyAccount/BasicInfo/BasicInfo.vue